import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const AddCustomer1Modal = ({ open, onClose, onSelected, searchValue }) => {
  const { token, user } = useAuth();
  const [search, setSearch] = useState('');
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!open || !token) return;
    setLoading(true);
    fetch('/api/customer1', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Owner-Id': user?.ownerId || user?.id || '',
        'X-Staff-Id': user?.staffId || ''
      }
    })
      .then(async res => {
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || 'Mijozlarni yuklashda xatolik');
        }
        return res.json();
      })
      .then(data => {
        setCustomers(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching customers:', err);
        toast.error(err.message || 'Mijozlarni yuklashda xatolik');
        setLoading(false);
      });
  }, [open, creating, token]);

  const filtered = searchValue
    ? customers.filter(c =>
        c.name.toLowerCase().includes(searchValue.toLowerCase()) ||
        (c.phone && c.phone.includes(searchValue))
      )
    : [];

  const handleSelect = (c) => {
    onSelected(c);
    setSelected(null);
    setSearch('');
    toast.success('Mijoz tanlandi');
    onClose();
  };

  const handleCreate = async () => {
    if (!name.trim() || !token) return;
    setCreating(true);
    try {
      const res = await fetch('/api/customer1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-Owner-Id': user?.ownerId || user?.id || '',
          'X-Staff-Id': user?.staffId || ''
        },
        body: JSON.stringify({ name, phone, ownerId: user?.ownerId || user?.id, staffId: user?.staffId })
      });
      if (!res.ok) {
        let msg = 'Failed to create customer';
        try {
          const data = await res.json();
          if (data && data.message) msg = data.message;
        } catch (_) {}
        throw new Error(msg);
      }
      const newCustomer = await res.json();
      setName('');
      setPhone('');
      setCreating(false);
      onSelected(newCustomer);
      setSelected(null);
      setSearch('');
      toast.success('Mijoz yaratildi');
      onClose();
    } catch (err) {
      console.error('Error creating customer:', err);
      toast.error(err.message || 'Mijoz yaratishda xatolik');
      setCreating(false);
    }
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Doimiy Mijoz Tanlash</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          <input
            className="form-control mb-1"
            placeholder="Ism"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <input
            className="form-control mb-2"
            placeholder="Telefon raqam"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
          <Button
            variant="success"
            className="mb-2 w-100"
            onClick={handleCreate}
            disabled={!name.trim() || creating}
          >
            {creating ? 'Yaratilmoqda...' : 'Yaratish'}
          </Button>
        </div>
        {searchValue && (loading ? <div>Yuklanmoqda...</div> : (
          <div style={{ maxHeight: 250, overflowY: 'auto' }}>
            {filtered.length === 0 ? <div>Mijoz topilmadi</div> : filtered.map(c => (
              <div
                key={c.id}
                className={`list-group-item list-group-item-action${selected && selected.id === c.id ? ' active' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => handleSelect(c)}
              >
                <div><b>{c.name}</b></div>
                <div style={{ fontSize: 13, color: '#888' }}>{c.phone}</div>
              </div>
            ))}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Bekor qilish</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomer1Modal; 